import React, { useRef } from 'react'
import PropTypes from 'prop-types'
import selectOneButton from '../assets/animations/selectOneButton'
import '../styles/d3/selectonebutton.scss'

import { useButtonAnimation } from '../utils/animations'

const SelectOneButton = props => {
  const { checked } = props
  const containerRef = useRef(null)
  useButtonAnimation(containerRef, selectOneButton, checked)

  return <div className='select-one-button' ref={containerRef} />
}

SelectOneButton.propTypes = {
  checked: PropTypes.bool
}

export default SelectOneButton
